import check from '../libraries/check-types-ext';
export default class ReceiptLine {
    constructor({ orderIndex, type, groupStart, quantity, name, amount, description, price, ean, plu, totalPrice, unitType, productId, rootProductId, absoluteRootProductId, configPriceModifier, options, discount, addedByGame = false, productConfigurations = [], }) {
        check.number.orFail(orderIndex);
        check.string.orFail(type);
        check.array.orFail(productConfigurations);
        if (type === ReceiptLineType.Product) {
            check.number.orFail(price);
            check.number.orFail(totalPrice);
            check.number.orFail(configPriceModifier);
        }
        this.orderIndex = orderIndex;
        this.type = type;
        this.productId = productId;
        if (rootProductId)
            this.rootProductId = rootProductId;
        if (absoluteRootProductId)
            this.absoluteRootProductId = absoluteRootProductId;
        this.quantity = quantity;
        this.groupStart = groupStart;
        this.name = name;
        this.amount = amount;
        this.description = description;
        this.price = price;
        this.ean = ean;
        this.plu = plu;
        this.options = options;
        this.totalPrice = totalPrice;
        this.configPriceModifier = configPriceModifier;
        this.unitType = unitType;
        this.discount = discount;
        this.productConfigurations = productConfigurations;
        this.addedByGame = addedByGame;
    }
}
export var ReceiptLineType;
(function (ReceiptLineType) {
    ReceiptLineType["Section"] = "Section";
    ReceiptLineType["ReturnableItem"] = "ReturnableItem";
    ReceiptLineType["Product"] = "Product";
    ReceiptLineType["Delivery"] = "Delivery";
})(ReceiptLineType || (ReceiptLineType = {}));
